import type { FC } from 'react';
import React, { useCallback } from 'react';
import cn from 'classnames';
import { useNamedContainers } from '@alfa-bank/site-named-container/src/named-container/utils';
import { getButtonViewByKind } from '@alfa-bank/site-button-v2/src/helpers/get-button-view-by-kind';

import type { TSecurityBlockComponentDesktop } from '../models';
import { DEFAULT_CONTENT_TEXT } from '../config';

export const SecurityWarrantyBlockDesktop: FC<
    React.PropsWithChildren<TSecurityBlockComponentDesktop>
> = ({
    Block,
    Button,
    IconBlock,
    Img,
    children,
    analytics,
    buttonDisable,
    buttonHidden = false,
    buttonInnerClassName,
    buttonKind = 'red',
    buttonText = 'Продолжить',
    buttonDataTestId = 'button',
    buttonLoading = false,
    className,
    content = DEFAULT_CONTENT_TEXT,
    dataTestId = 'SecurityWarrantyBlock',
    onClick,
    styles,
    submit = true,
    sendEvent,
    SecurityContentBlock,
    iconSettings,
    ...restBlockProps
}) => {
    const buttonView = getButtonViewByKind(buttonKind);
    const { icon, securityContent } = useNamedContainers(children);

    const handleClick = useCallback(() => {
        sendEvent(analytics);

        if (onClick) {
            onClick();
        }
    }, [analytics, onClick, sendEvent]);

    return (
        <Block
            className={cn(styles.external, styles.wrapper, className)}
            paddedType="perimeter16"
            theme="grey"
            {...restBlockProps}
        >
            <Block
                className={cn(styles.external, styles.security)}
                data-test-id={dataTestId}
                notPadded
            >
                <IconBlock iconSettings={iconSettings}>{icon}</IconBlock>
                <SecurityContentBlock buttonHidden={buttonHidden} content={content}>
                    {securityContent}
                </SecurityContentBlock>
            </Block>
            {!buttonHidden && (
                <Block className={cn(styles.external, styles.buttonWrapper)} notPadded>
                    <Button
                        block
                        borderRadius={8}
                        colors="default"
                        dataTestId={buttonDataTestId}
                        disabled={buttonDisable}
                        innerClassName={buttonInnerClassName}
                        loading={buttonLoading}
                        onClick={handleClick}
                        size="s"
                        type={submit ? 'submit' : 'button'}
                        view={buttonView}
                    >
                        {buttonText}
                    </Button>
                </Block>
            )}
        </Block>
    );
};
